var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7049 0H3.66443C1.85204 0 0.382812 1.48655 0.382812 3.32031V30.6797C0.382812 32.5134 1.85204 34 3.66443 34H30.7049C32.5173 34 33.9866 32.5134 33.9866 30.6797V3.32031C33.9866 1.48655 32.5173 0 30.7049 0Z",
    fill: "url(#paint0_linear_1025_46450)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0431 4.41992H20.9443C20.0744 4.41992 19.3691 5.13347 19.3691 6.01367V17.7012C19.3691 18.5814 20.0744 19.2949 20.9443 19.2949H28.0431C28.9131 19.2949 29.6183 18.5814 29.6183 17.7012V6.01367C29.6183 5.13347 28.9131 4.41992 28.0431 4.41992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4259 4.41992H6.32713C5.45718 4.41992 4.75195 5.13347 4.75195 6.01367V26.2012C4.75195 27.0814 5.45718 27.7949 6.32713 27.7949H13.4259C14.2959 27.7949 15.0011 27.0814 15.0011 26.2012V6.01367C15.0011 5.13347 14.2959 4.41992 13.4259 4.41992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1025_46450",
    x1: 17.1847,
    y1: 0,
    x2: 17.1847,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6038,
    height: 34,
    fill: "white",
    transform: "translate(0.382812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTrello);
export default __webpack_public_path__ + "static/media/logos_trello.89f8beda0509f82e412b47735eebb9eb.svg";
export { ForwardRef as ReactComponent };